import { motion } from 'framer-motion';
import React, { PropsWithChildren } from 'react';

export const Transition: React.FC<PropsWithChildren> = ({ children }) => (
  <div style={{ position: 'relative' }}>
    <motion.div
      initial={{
        height: '100%',
        opacity: 0,
        position: 'relative',
        top: -20,
      }}
      animate={{ opacity: 1, top: 0 }}
      transition={{ duration: 0.75 }}
      exit={{ opacity: 0 }}>
      {children}
    </motion.div>
  </div>
);
